function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 36,
  r: 36,
  fill: "#68D4F8"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#E6F9FF",
  d: "M46.62 32.15l4.34 2.44c1.38.77 1.38 2.03 0 2.8l-12.48 7.02a5.64 5.64 0 01-4.99 0L21.02 37.4c-1.38-.77-1.38-2.03 0-2.8l4.35-2.46 7.16 4.02.1.05a7.64 7.64 0 006.75 0l.1-.05 7.14-4.01z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#CEF2FF",
  d: "M46.62 42.15l4.34 2.44c1.38.77 1.38 2.03 0 2.8l-12.48 7.02a5.64 5.64 0 01-4.99 0L21.02 47.4c-1.38-.77-1.38-2.03 0-2.8l4.35-2.46 7.16 4.02.1.05a7.64 7.64 0 006.75 0l.1-.05 7.14-4.01z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M38.48 17.47l12.48 7.02c1.38.78 1.38 2.03 0 2.8l-12.48 7.02a5.64 5.64 0 01-4.99 0L21.02 27.3c-1.38-.78-1.38-2.03 0-2.8l12.47-7.02a5.65 5.65 0 015 0z"
});

function SvgPlatformManagement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 72 72"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3MiA3MiI+PGNpcmNsZSBjeD0iMzYiIGN5PSIzNiIgcj0iMzYiIGZpbGw9IiM2OEQ0RjgiLz48cGF0aCBmaWxsPSIjRTZGOUZGIiBkPSJNNDYuNjIgMzIuMTVsNC4zNCAyLjQ0YzEuMzguNzcgMS4zOCAyLjAzIDAgMi44bC0xMi40OCA3LjAyYTUuNjQgNS42NCAwIDAgMS00Ljk5IDBMMjEuMDIgMzcuNGMtMS4zOC0uNzctMS4zOC0yLjAzIDAtMi44bDQuMzUtMi40NiA3LjE2IDQuMDIuMS4wNWE3LjY0IDcuNjQgMCAwIDAgNi43NSAwbC4xLS4wNSA3LjE0LTQuMDF6Ii8+PHBhdGggZmlsbD0iI0NFRjJGRiIgZD0iTTQ2LjYyIDQyLjE1bDQuMzQgMi40NGMxLjM4Ljc3IDEuMzggMi4wMyAwIDIuOGwtMTIuNDggNy4wMmE1LjY0IDUuNjQgMCAwIDEtNC45OSAwTDIxLjAyIDQ3LjRjLTEuMzgtLjc3LTEuMzgtMi4wMyAwLTIuOGw0LjM1LTIuNDYgNy4xNiA0LjAyLjEuMDVhNy42NCA3LjY0IDAgMCAwIDYuNzUgMGwuMS0uMDUgNy4xNC00LjAxeiIvPjxwYXRoIGZpbGw9IiNGRkYiIGQ9Ik0zOC40OCAxNy40N2wxMi40OCA3LjAyYzEuMzguNzggMS4zOCAyLjAzIDAgMi44bC0xMi40OCA3LjAyYTUuNjQgNS42NCAwIDAgMS00Ljk5IDBMMjEuMDIgMjcuM2MtMS4zOC0uNzgtMS4zOC0yLjAzIDAtMi44bDEyLjQ3LTcuMDJhNS42NSA1LjY1IDAgMCAxIDUgMHoiLz48L3N2Zz4K";
export { SvgPlatformManagement as ReactComponent };